import { createAction } from 'redux-actions';

export const getSettingSeminarRoomRequested = createAction('GET_SETTING_SEMINAR_ROOM_REQUEST');
export const getSettingSeminarRoomReceived = createAction('GET_SETTING_SEMINAR_ROOM_RECEIVED');
export const getSettingSeminarRoomReceiveFailure = createAction('GET_SETTING_SEMINAR_ROOM_RECEIVE_FAILURE');
export const getSettingSeminarRoomClear = createAction('GET_SETTING_SEMINAR_ROOM_CLEAR');

export const updateSettingSeminarRoomRequested = createAction('UPDATE_SETTING_SEMINAR_ROOM_REQUEST');
export const updateSettingSeminarRoomReceived = createAction('UPDATE_SETTING_SEMINAR_ROOM_RECEIVED');
export const updateSettingSeminarRoomReceiveFailure = createAction('UPDATE_SETTING_SEMINAR_ROOM_RECEIVE_FAILURE');
export const updateSettingSeminarRoomClear = createAction('UPDATE_SETTING_SEMINAR_ROOM_CLEAR');
